export const campaignformat = {
    methods: {
        campaignformat(date){
            return date.slice(0,4) + '/' + date.slice(4,6) + '/' + date.slice(6,8) + '~' + date.slice(8,12) + '/' + date.slice(12,14) + '/' + date.slice(14,16)
        }
    }
}